import { useProposalDocument } from "./proposalDocumentsContext";

const Testimonials: React.FC = () => {
  const { payload, setPayload } = useProposalDocument();

  return (
    <div className="card mb-4" hidden>
      <div className="card-header bg-success text-white d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Testimonials</h4>
        <button
          type="button"
          className="btn btn-sm btn-light"
          onClick={() => {
            setPayload({
              ...payload,
              testimonials: [...payload.testimonials, { quote: "", author: "", company: "" }],
            });
          }}
        >
          + Add Testimonial
        </button>
      </div>
      <div className="card-body">
        {payload.testimonials.map((test, index) => (
          <div key={index} className="border p-3 mb-3 position-relative">
            <button
              type="button"
              className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
              onClick={() => {
                const newT = [...payload.testimonials];
                newT.splice(index, 1);
                setPayload({ ...payload, testimonials: newT });
              }}
            >
              X
            </button>
            <div className="row">
              <div className="col-md-6 mb-2">
                <input
                  className="form-control"
                  placeholder="Author"
                  value={test.author}
                  onChange={(e) => {
                    const newT = [...payload.testimonials];
                    newT[index].author = e.target.value;
                    setPayload({ ...payload, testimonials: newT });
                  }}
                />
              </div>
              <div className="col-md-6 mb-2">
                <input
                  className="form-control"
                  placeholder="Company"
                  value={test.company}
                  onChange={(e) => {
                    const newT = [...payload.testimonials];
                    newT[index].company = e.target.value;
                    setPayload({ ...payload, testimonials: newT });
                  }}
                />
              </div>
              <div className="col-12">
                <textarea
                  className="form-control"
                  placeholder="Quote"
                  rows={3}
                  value={test.quote}
                  onChange={(e) => {
                    const newT = [...payload.testimonials];
                    newT[index].quote = e.target.value;
                    setPayload({ ...payload, testimonials: newT });
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
